// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__iG3qN","label":"LabeledBox_label__r0m6X"};